/**
 * Shared scalar types for the Augmented War engine (basic game, rule.md v0.9).
 */

/** The two players. Home `owner` 1/2 in `hex-board-v2.json` maps to p1/p2. */
export type PlayerId = "p1" | "p2";

export const PLAYER_IDS: readonly PlayerId[] = ["p1", "p2"] as const;

/** Faction identities (rule.md §9). */
export type Faction = "beast" | "night" | "federation";

/** Standard engine validation result — Result type, never thrown. */
export interface ValidationResult {
  readonly valid: boolean;
  readonly error?: string;
  readonly details?: Record<string, unknown>;
}

/** Convenience constructors keep validators terse and side-effect-free. */
export const valid: ValidationResult = { valid: true };
export const invalid = (
  error: string,
  details?: Record<string, unknown>,
): ValidationResult =>
  details ? { valid: false, error, details } : { valid: false, error };
